'use es6';

import getIn from 'transmute/getIn';
export const getIndexedAsyncInlineImageStatusData = getIn(['threadViewRootReducer', 'inlineImageStatus']);